// ============================================================
//  MAIN — wires everything together inside jQuery(document).ready()
//  Load this file LAST, with <script type="module">.
// ============================================================

import { STOCK_MESSAGES } from "./apartment-config.js";
import {
  updateViewportWidth,
  showGlobalLoader,
  hideGlobalLoader,
  formatMoney,
} from "./apartment-utils.js";
import { rcToast } from "./apartment-toast.js";
import { variantHasStock } from "./apartment-stock.js";
import { calculateGrandTotal, updateCommunityPrices } from "./apartment-fees.js";
import { buildCartItems, collectCartAttributes } from "./apartment-cart.js";
import {
  check_filter_display,
  applyFilters,
  saveFilterState,
  restoreFilterState,
  renderActiveFilterChips,
  debouncedApplyFilters,
} from "./apartment-filters.js";
import {
  saveApartmentFormState,
  restoreApartmentFormState,
} from "./apartment-form-state.js";
import { custom_splide_slider } from "./apartment-slider.js";

// --- bfcache: re-enable the submit button on back-navigation ---
window.addEventListener("pageshow", function (event) {
  hideGlobalLoader();
  if (event.persisted) {
    var $btn = document.getElementById("add-to-cart-btn");
    if ($btn) {
      $btn.disabled = false;
      $btn.removeAttribute("disabled");
    }
  }
});

jQuery(document).ready(function ($) {
  "use strict";
  const $form = $("#product-form");
  const $variantInput = $("#selected-variant-id");
  const $communityFeesElement = $("[data-community-fees]");
  const $grandTotalElement = $("[data-calculator-grand-total]");
  const $apartmentDepositElement = $("[data-apartment-deposit]");

  // 1. SPLIDE
  $(document).on("click", ".slider_nav_wrap_left span", function () {
    $(this).parents(".custom_splide_has_arrows").find(".splide__arrow--prev").trigger("click");
  });
  $(document).on("click", ".slider_nav_wrap_right span", function () {
    $(this).parents(".custom_splide_has_arrows").find(".splide__arrow--next").trigger("click");
  });

  custom_splide_slider(".des_gallery", ">", "slide", false, false, false, "0",
    5, 0, 24, 1460, 4, 0, 24, 1200, 3, 0, 24, 767, 1, 0, 20);
  custom_splide_slider(".erd_content_blocks", ">", "slide", false, false, false, "0",
    3, 0, 24, 1460, 3, 0, 24, 1200, 2, 0, 24, 700, 1, 0, 20);

  // 2. LIGHTBOX
  if ($(".el_has_popup_img").length) {
    const lightbox = new PhotoSwipeLightbox({
      gallery: ".list_has_photoswipe_imgs", children: "a",
      showHideAnimationType: "none", showAnimationDuration: 0, hideAnimationDuration: 0,
      pswpModule: PhotoSwipe,
      isClickableElement: function (el) {
        return el.tagName === "IMG" || el.classList.contains("pswp__button--zoom");
      },
    });
    lightbox.addFilter("domItemData", (itemData) => {
      if (!itemData.width || !itemData.height) { itemData.width = 1920; itemData.height = 1080; }
      return itemData;
    });
    lightbox.addFilter("contentLoad", (content) => {
      if (!content.data.isLoadedCustom) {
        const img = new Image();
        img.src = content.data.src;
        img.onload = () => {
          content.data.width = img.naturalWidth;
          content.data.height = img.naturalHeight;
          content.data.isLoadedCustom = true;
          if (content.instance && content.instance.currSlide === content.slide) {
            content.instance.currSlide.updateSize(true);
            content.instance.refreshWithData();
          }
        };
      }
    });
    lightbox.init();
  }

  // 3. VIEWPORT
  updateViewportWidth();
  $(window).on("resize orientationchange", function () { updateViewportWidth(); });

  // 4. MOBILE MENU
  $(".m_menu_opener").click(function (e) {
    e.preventDefault();
    $("body").addClass("mobile_menu_active");
    $(this).parent(".mobile_menu_wrap").next(".menu_wrap").addClass("active_mobile_menu");
  });
  $(".m_menu_close").click(function (e) {
    e.preventDefault();
    $(".drop_down_trigger").removeClass("active_dd_trigger");
    $(".drop_down_trigger + ul").removeClass("active_dd");
    $("body").removeClass("mobile_menu_active");
    $(this).parent(".menu_panel_header").parent(".menu_wrap").removeClass("active_mobile_menu");
  });
  $(".drop_down_trigger").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active_dd_trigger");
    $(this).next("ul").toggleClass("active_dd");
  });

  // 5. AUTO SCROLLING
  $(".auto_scrolling_content").each(function () {
    var $list = $(this);
    var $items = $list.children();
    $list.append($items.clone());
    $list.append($items.clone());

    let scrollPos = 0, isPaused = false, isDragging = false;
    let scrollSpeed = 0.5, listWidth = 0;

    const calculateWidth = () => {
      let total = 0;
      const gap = parseInt($list.css("column-gap")) || 0;
      $items.each(function () { total += this.getBoundingClientRect().width + gap; });
      listWidth = total;
    };

    $(window).on("load resize", calculateWidth);
    setTimeout(calculateWidth, 500);

    const step = () => {
      if (!isPaused && !isDragging && listWidth > 0) {
        scrollPos -= scrollSpeed;
        if (scrollPos <= -listWidth) scrollPos += listWidth;
        $list.css("transform", `translate3d(${scrollPos}px, 0, 0)`);
      }
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);

    $list.on("mouseenter", () => (isPaused = true));
    $list.on("mouseleave", () => { if (!isDragging) isPaused = false; });
    $list.on("touchstart", () => (isPaused = true));
    $list.on("touchend", () => { setTimeout(() => { if (!isDragging) isPaused = false; }, 200); });

    let startX = 0;
    $list.on("mousedown touchstart", (e) => {
      isDragging = true; isPaused = true;
      let pageX = e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX) || 0;
      startX = pageX - scrollPos;
    });

    $(window).on("mousemove touchmove", (e) => {
      if (!isDragging) return;
      let pageX = e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX) || 0;
      scrollPos = pageX - startX;
      if (listWidth > 0) scrollPos = ((scrollPos % listWidth) - listWidth) % listWidth;
      $list.css("transform", `translate3d(${scrollPos}px, 0, 0)`);
    });

    $(window).on("mouseup touchend", () => { isDragging = false; });
  });

  // 6. FILTER UI
  $(".single_filter_i_top:not(.more_filter_button_trigger)").click(function () {
    $(this).toggleClass("current_f_active");
    $(this).parents(".single_filter_i").toggleClass("active_f_dd");
    $(this).next(".single_filter_i_toggle_block").slideToggle();
  });

  $(".more_filter_button_trigger").click(function () {
    $(this).toggleClass("current_f_active");
    $(".wb_filter_bottom_row").toggleClass("active_more_filters").slideToggle();
  });

  check_filter_display();
  $(window).on("resize", function () { check_filter_display(); });

  $(".main_filter_toggle_m_button").click(function () {
    var check_for_current_status = $(this).hasClass("active_mob_filter_trigger");
    var check_for_more_filter_el = $(".wb_filter_bottom_row ").hasClass("active_more_filters");
    if (check_for_more_filter_el && check_for_current_status) {
      $(".more_filter_button_trigger ").trigger("click").removeClass("active_f_dd");
      $(".more_filter_button_trigger .single_filter_i_top").removeClass("current_f_active");
    }
    $(this).toggleClass("active_mob_filter_trigger");
    $(this).next(".web_filter_wrap").toggleClass("active_mob_filter").slideToggle();
  });

  var overflow_scrolling_selector = ".single_filter_i_middle > ul";
  if ($(overflow_scrolling_selector).length) {
    var { OverlayScrollbars } = OverlayScrollbarsGlobal;
    $(overflow_scrolling_selector).each(function () {
      OverlayScrollbars(this, {
        overflow: { y: "scroll", x: "hidden" },
        scrollbars: { visibility: "visible", autoHide: "never" },
      });
    });
  }

  if (restoreFilterState()) { applyFilters(); renderActiveFilterChips(); }

  $(document).on("click", ".active_filter_chip_remove", function (e) {
    e.preventDefault();
    var $chip = $(this).closest(".active_filter_chip");
    var type = $chip.attr("data-filter-type");
    var name = $chip.attr("data-filter-name");
    var value = $chip.attr("data-filter-value");

    if (type === "amenity" || type === "destination" || type === "cohort") {
      $('input[name="' + name + '"][value="' + value + '"]').prop("checked", false).trigger("change");
      $('input[name="' + name + '"][value="' + value + '"]').closest(".amenity_filter_item").removeClass("active");
    } else if (type === "counter") {
      var $inp = $('input[name="' + name + '"]');
      var min = parseInt($inp.attr("min"), 10) || 0;
      $inp.val(min).trigger("change");
    } else if (type === "price") {
      var $s = $("#priceSlider");
      var max = parseFloat($s.attr("max")) || 0;
      $s.val(max).trigger("change");
      $("#currentValueInput").val(max).text(max);
    }

    saveFilterState(); renderActiveFilterChips(); applyFilters();
  });

  // 7. GUEST COUNTER (capacity check)
  var maxCapacity = parseInt($("#apartment-data").data("max-capacity"), 10) || 0;
  var $notice = $(".guest_capacity_notice");
  var originalNoticeHTML = $notice.find("p").html();

  function showCapacityNotice(message) {
    if (!$notice.length) return;
    if (message) $notice.find("p").html(message);
    else $notice.find("p").html(originalNoticeHTML);
    $notice.stop(true, true).fadeIn(200);
    clearTimeout($notice.data("hideTimer"));
    $notice.data("hideTimer", setTimeout(function () { $notice.fadeOut(300); }, 2500));
  }

  $(".trigger_inc").on("click", function () {
    var $btn = $(this);
    var $input = $btn.siblings('input[type="number"]');
    var currentValue = parseInt($input.val(), 10) || 0;
    var counterProperty = $btn.attr("data-counter-property") || $input.attr("data-counter-property");
    var inputType = $input.attr("data-input-type") || $btn.attr("data-input-type");

    if (
      (inputType !== "guests" && counterProperty !== "Adults") ||
      (inputType !== "guests" && counterProperty !== "Children (beds)") ||
      (inputType === "guests" && counterProperty === "Baby (crib)")
    ) {
      var fieldMax = parseInt($input.attr("max"), 10);
      if (!isNaN(fieldMax) && currentValue >= fieldMax) {
        var label = counterProperty || "guests";
        if (fieldMax === 1 && /s$/.test(label)) label = label.replace(/s$/, "");
        return;
      }
    }

    if (inputType === "guests" && counterProperty !== "Baby (crib)") {
      var totalGuests = 0;
      $('input[data-input-type="guests"]').each(function () {
        if ($(this).attr("data-counter-property") === "Baby (crib)") return;
        totalGuests += parseInt($(this).val(), 10) || 0;
      });
      if (totalGuests >= maxCapacity) { showCapacityNotice(null); return; }
    }

    $input.val(currentValue + 1);
    $input.trigger("change");
  });

  $(".trigger_dec").on("click", function () {
    var $input = $(this).siblings('input[type="number"]');
    var currentValue = parseInt($input.val()) || 0;
    var min = parseInt($input.attr("min")) || 0;
    if (currentValue > min) { $input.val(currentValue - 1); $input.trigger("change"); }
  });

  // 8. PRICE SLIDER
  const $slider = $("#priceSlider");
  const $input = $("#currentValueInput");
  const minVal = parseInt($slider.attr("min")) || 200;
  const maxVal = parseInt($slider.attr("max")) || 4000;
  const stepVal = parseInt($slider.attr("step")) || 10;

  $slider.on("input", function () { $input.val($(this).val()); });
  $input.on("change", function () {
    let val = parseInt($(this).val());
    if (isNaN(val)) val = minVal;
    if (val < minVal) val = minVal;
    if (val > maxVal) val = maxVal;
    val = Math.round((val - minVal) / stepVal) * stepVal + minVal;
    $slider.val(val);
    $(this).val(val);
  });

  // 9. SHOW ALL PHOTOS
  $(".sa_show_all_photos").click(function (e) {
    e.preventDefault();
    $(this).parent(".sa_slider_wrap_bottom").prev(".sa_slider_wrap_top")
      .find(".sa_slider_wrap_top_i_gallery > div:first-child a img").trigger("click");
  });

  // 10. READ MORE / LESS
  $(".readmore_text_toggle").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active_rm_trigger");
    $(this).parents(".read_more_content_block_wrap").toggleClass("active_rm_txt_block");
    $(this).parent(".readmore_text_toggle_wrap").prev(".read_more_content_block").slideToggle().toggleClass("text_block_active");
  });

  // FILTER SAVE BUTTON
  $(document).on("click", ".save_current_filter", function (e) {
    e.preventDefault();
    const $filter = $(this).closest(".single_filter_i");
    $filter.find(".single_filter_i_top:not(.more_filter_button_trigger)").toggleClass("current_f_active");
    $filter.toggleClass("active_f_dd");
    $(this).closest(".single_filter_i_toggle_block").slideToggle();
    applyFilters(); saveFilterState(); renderActiveFilterChips();
  });

  $("#priceSlider").on("input", function () {
    const val = $(this).val();
    $("#currentValueInput").text(val);
    debouncedApplyFilters(applyFilters); saveFilterState(); renderActiveFilterChips();
  });

  $(document).on("change click", 'input[name="outdoor_amenities[]"], input[name="indoor_amenities[]"]', function () {
    debouncedApplyFilters(applyFilters); saveFilterState(); renderActiveFilterChips();
  });

  $(document).on("change", 'input[name="destinations_name[]"]', function () { debouncedApplyFilters(applyFilters); });

  $(document).on("click", ".amenity_filter_item", function () {
    var $checkbox = $(this).find('input[type="checkbox"]');
    $checkbox.prop("checked", !$checkbox.prop("checked")).trigger("change");
    $(this).toggleClass("active", $checkbox.prop("checked"));
  });

  // 11. VARIANT DROPDOWN
  $(document).on("click", ".custom_dropdown_toggle", function (e) {
    const $this = $(this);
    const $wrapper = $this.closest(".custom_variant_dropdown_wrap");
    const $menu = $this.next(".custom_dropdown_options");
    $this.toggleClass("current_f_active");
    $wrapper.toggleClass("active_f_dd");
    $menu.slideToggle();
    e.stopPropagation();
  });

  $(document).on("click", ".custom_dropdown_option", function (e) {
    e.stopPropagation();
    const $option = $(this);

    // ── Sold-out / disabled options are not selectable ──
    if ($option.hasClass("sold-out") || $option.is("[disabled]")) {
      rcToast(STOCK_MESSAGES.soldOut, { variant: "error" });
      return;
    }

    const variantId = $option.attr("data-variant-id");

    // ── Extra stock guard: even if the class is missing (stale render),
    //    verify inventory_quantity is > 0 before allowing selection. ──
    if (!variantHasStock(variantId)) {
      rcToast(STOCK_MESSAGES.soldOut, { variant: "error" });
      return;
    }

    const community_fees_adult = $option.attr("data-community-price-adult");
    const community_fee_child = $option.attr("data-community-price-child");

    $(".custom_dropdown_toggle").attr("data-community-fee-adult", community_fees_adult);
    $(".custom_dropdown_toggle").attr("data-community-fee-child", community_fee_child);

    updateCommunityPrices();

    const variantLabel = $option.text().trim();
    $("#selected-variant-id").val(variantId);
    $("#selected-variant-label").text(variantLabel).removeClass("placeholder_active");

    const variant = (window.apartmentVariants || []).find(function (v) {
      return String(v.id) === String(variantId);
    });
    const priceCents = variant ? Number(variant.price) : 0;
    const priceFormatted = formatMoney(priceCents, $form);
    $(".s_des_abt_sec_inner_i_right #product_price").text(priceFormatted);

    $(".custom_dropdown_options").slideUp();
  });

  // 12. APARTMENT CALCULATOR
  if (!$form.length) { console.warn("Apartment calculator: Product form not found."); return; }
  if (!$communityFeesElement.length || !$grandTotalElement.length) { console.warn("Apartment calculator: Total elements not found."); return; }

  $form.on("input change", "[data-calculator-input]", function () {
    calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
  });

  $form.on("click", "[data-quantity-decrease], [data-quantity-increase]", function () {
    var $control = $(this).closest(".text_quantity_control");
    if (!$control.length) return;
    var $input = $control.find("[data-calculator-input]");
    if (!$input.length) return;
    setTimeout(function () {
      calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
    }, 0);
  });

  if ($variantInput.length) {
    $variantInput.on("change", function () {
      calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
    });
    var variantObserver = new MutationObserver(function () {
      calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
    });
    variantObserver.observe($variantInput[0], { attributes: true, attributeFilter: ["value"] });
  }

  // ─── FIX: reliable purchase-option listeners ───
  $(document).on("change", 'input[name="purchase_option"]', function () {
    calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
  });

  $(document).on(
    "click",
    '#hypehound-pre-orders, [name="purchase_option"], ' +
    '#purchase-option-deposit-wrapper, #purchase-option-full-wrapper, ' +
    '#purchase-option-deposit-wrapper label, #purchase-option-full-wrapper label',
    function () {
      setTimeout(function () {
        calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
      }, 0);
    }
  );

  (function observePurchaseOptions() {
    var watched = new WeakSet();

    function attach($radio) {
      if (!$radio.length || !$radio[0] || watched.has($radio[0])) return;
      watched.add($radio[0]);
      var obs = new MutationObserver(function () {
        calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
      });
      obs.observe($radio[0], { attributes: true, attributeFilter: ["checked"] });
    }

    function scan() {
      $('input[name="purchase_option"]').each(function () { attach($(this)); });
    }

    scan();
    setTimeout(scan, 500);
    setTimeout(scan, 2000);
  })();

  (function waitForPurchaseOptions() {
    var recalc = function () {
      calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);
    };
    if ($('input[name="purchase_option"]:checked').length) { setTimeout(recalc, 0); return; }
    var obs = new MutationObserver(function () {
      if ($('input[name="purchase_option"]:checked').length) {
        obs.disconnect();
        setTimeout(recalc, 0);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  })();

  restoreApartmentFormState();
  updateCommunityPrices();
  calculateGrandTotal($form, $variantInput, $communityFeesElement, $grandTotalElement, $apartmentDepositElement);

  $(document).on("change", "[data-terms-checkbox]", function () {
    if (this.checked) {
      var $wrap = $(this).closest("[data-terms-wrap]");
      $wrap.removeClass("has_error");
      $wrap.find("[data-terms-error]").css("display", "none");
    }
  });

  // ============================================================
  //  13. FORM SUBMISSION
  // ============================================================
  $(document).on("submit", "#product-form", function (e) {
    if (!window.apartmentVariants) return;

    var $form = $(this);
    saveApartmentFormState();

    var apartmentVariantId = $("#selected-variant-id").val();

    // ── 1) No variant picked yet ───────────────────────────
    if (!apartmentVariantId) {
      e.preventDefault();
      var $datesBlock = $("[data-dates-block]");
      var $toggle = $datesBlock.find(".custom_dropdown_toggle");
      $toggle.addClass("rc-field-error").css({
        "border-color": "#E68A6F",
        "box-shadow": "0 0 0 2px rgba(230,138,111,0.25)",
      });
      if ($datesBlock.length) $("html, body").animate({ scrollTop: $datesBlock.offset().top - 120 }, 300);
      rcToast("Please select a date before booking.", { variant: "error" });
      setTimeout(function () { $toggle.trigger("focus"); }, 320);
      return;
    }

    // ── 2) Variant picked but sold out ─────────────────────
    var currentVariant = window.apartmentVariants.find(function (v) {
      return String(v.id) === String(apartmentVariantId);
    });

    if (!currentVariant || !currentVariant.available) {
      e.preventDefault();
      rcToast(STOCK_MESSAGES.unavailable, { variant: "error" });
      return;
    }

    // ── 2b) Explicit stock check (qty > 0, blocks -1 / 0 / unknown) ──
    if (!variantHasStock(apartmentVariantId)) {
      e.preventDefault();
      rcToast(STOCK_MESSAGES.soldOut, { variant: "error" });
      return;
    }

    // ── 3) Validate every community-required field ─────────
    var $invalidField = null;
    var invalidLabel = "";

    $("[data-community-required]").each(function () {
      if ($invalidField) return;
      var $field = $(this);
      var value = parseInt($field.val(), 10);
      var minAttr = parseInt($field.attr("min"), 10);
      var requiredMin = Math.max(1, isNaN(minAttr) ? 1 : minAttr);

      if (isNaN(value) || value < requiredMin) {
        $invalidField = $field;
        var $label = $field.closest("label");
        if ($label.length) {
          var labelText = $.trim($label.find("span").first().text());
          if (labelText) invalidLabel = labelText;
        }
        if (!invalidLabel) invalidLabel = $field.attr("data-counter-property") || "this field";
      }
    });

    if ($invalidField) {
      e.preventDefault();
      $invalidField.addClass("rc-field-error").css({
        "border-color": "#E68A6F",
        "box-shadow": "0 0 0 2px rgba(230,138,111,0.25)",
      });
      var $communityBlock = $invalidField.closest(".aprtmnt_top_info");
      if ($communityBlock.length) $("html, body").animate({ scrollTop: $communityBlock.offset().top - 100 }, 300);
      rcToast("Please fill in \u201C" + invalidLabel + "\u201D before booking.", { variant: "error" });
      setTimeout(function () { $invalidField.trigger("focus"); }, 320);
      return;
    }

    // ── 4) Terms & Conditions ──────────────────────────────
    var $terms = $form.find("[data-terms-checkbox][data-terms-required]");
    if ($terms.length && !$terms.prop("checked")) {
      e.preventDefault();
      var $wrap = $terms.closest("[data-terms-wrap]");
      var $err = $wrap.find("[data-terms-error]");
      $wrap.addClass("has_error");
      $err.css("display", "block");
      $("html, body").animate({ scrollTop: $wrap.offset().top - 120 }, 300);
      rcToast("Please accept the Terms & Conditions to continue.", { variant: "error" });
      setTimeout(function () { $terms.trigger("focus"); }, 320);
      return;
    }

    // ── 5) All checks passed → AJAX submit ─────────────────
    e.preventDefault();
    showGlobalLoader();

    var $btn = $form.find("#add-to-cart-btn");
    $btn.prop("disabled", true).html(
      'Processing… <span class="web_btn_icon"><span class="material-symbols-outlined">hourglass_top</span></span>'
    );

    var items = buildCartItems();
    var attributes = collectCartAttributes();

    if (!items.length) {
      hideGlobalLoader();
      $btn.prop("disabled", false).html(
        'Add to cart <span class="web_btn_icon"><span class="material-symbols-outlined">arrow_right_alt</span></span>'
      );
      rcToast(STOCK_MESSAGES.buildError, { variant: "error" });
      return;
    }

    fetch("/cart/clear.js", { method: "POST" })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to clear cart");
        return response.json();
      })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            console.error("Shopify /cart/add.js error:", text);
            throw new Error("Failed to add booking to cart");
          });
        }
        return response.json();
      })
      .then(function () {
        if (!attributes || !Object.keys(attributes).length) return null;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify({ attributes: attributes }),
        });
      })
      .then(function () {
        window.location.href = "/checkout";
      })
      .catch(function (error) {
        console.error("Error processing booking:", error);
        hideGlobalLoader();
        $btn.prop("disabled", false).html(
          'Add to cart <span class="web_btn_icon"><span class="material-symbols-outlined">arrow_right_alt</span></span>'
        );
        rcToast(STOCK_MESSAGES.genericError, { variant: "error" });
      });
  });

  /* Remove error highlight when customer edits the field */
  $(document).on("input change", "[data-community-required].rc-field-error", function () {
    $(this).removeClass("rc-field-error").css({ "border-color": "", "box-shadow": "" });
  });

  // Terms popup
  (function () {
    "use strict";
    function boot() {
      var trigger = document.querySelector("[data-terms-popup-open]");
      var modal = document.querySelector("[data-terms-popup]");
      if (!trigger || !modal) return;

      var opened = false;

      function openModal(e) {
        if (e) e.preventDefault();
        if (opened) return;
        opened = true;
        modal.hidden = false;
        document.body.classList.add("aprtmnt_terms_modal_open");
        document.addEventListener("keydown", onKey);
        var closeBtn = modal.querySelector(".aprtmnt_terms_modal_close");
        if (closeBtn) { try { closeBtn.focus(); } catch (_) {} }
      }

      function closeModal() {
        if (!opened) return;
        opened = false;
        modal.hidden = true;
        document.body.classList.remove("aprtmnt_terms_modal_open");
        document.removeEventListener("keydown", onKey);
        try { trigger.focus(); } catch (_) {}
      }

      function onKey(e) {
        if (e.key === "Escape") { e.preventDefault(); closeModal(); }
      }

      trigger.addEventListener("click", openModal);
      modal.addEventListener("click", function (e) {
        var closeEl = e.target.closest && e.target.closest("[data-terms-popup-close]");
        if (closeEl) { e.preventDefault(); closeModal(); return; }
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a) return;
        var id = a.getAttribute("href").slice(1);
        if (!id) return;
        var target = modal.querySelector("#" + CSS.escape(id));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
  })();

  updateCommunityPrices();
});